/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ThirdPartyCardChangeStateCommand = {
    /**
     * Card token.
     */
    token: string;
    /**
     * Card state.
     */
    state: ThirdPartyCardChangeStateCommand.state;
};
export namespace ThirdPartyCardChangeStateCommand {
    /**
     * Card state.
     */
    export enum state {
        ACTIVE = 'ACTIVE',
        BLOCKED = 'BLOCKED',
        EXPIRED = 'EXPIRED',
    }
}

